<script>
  import solicitacaoCores from '~js/solicitacao-cores';

  export default {
    props: {
      itens: Array,
      carregando: {
        type: Boolean,
        required: false,
        default: false
      },
      titleCard: String,
      textoBotao: String,
      rotaBotao: [String, Object],
      semItemTexto: String,
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        solicitacaoCores: solicitacaoCores,
      }
    },
    methods: {
      corDoModulo(modulo) {
        const cor = this.solicitacaoCores.filter(s => s.id == modulo)[0];
        return cor || {};
      },
      retornaClassIcone(item) {
        return item.icone || this.corDoModulo(item.modulo).icone;
      },
      retornaClassCor(item) {
        return item.cor || this.corDoModulo(item.modulo).cor;
      },
      retornaCorBadge(item) {
        return this.retornaClassCor(item) + "b0";
      },
    },
    computed: {
        mostrarItens() {
            return this.itens.length > 0;
        }
    }
  }
</script>

<template>
    <div class="card-notificacao">
        <div class="ibox ">
            <div class="ibox-title">
                <h5 class="MuiTypography-h6">{{titleCard}}</h5>
            </div>
            <div class="ibox-content" style="padding: 0px 15px 15px;">
                <div class="feed-activity-list">
                    <div class="TextoListagem text-center" v-if="carregando" style="margin-top: 12px;">
                        <i class='fa fa-spinner fa-pulse'></i>  Carregando...
                    </div>
                    <div v-else class="feed-element" style="padding-bottom: 0px;">
                        <ul class="list-group clear-list" style="margin-bottom: 0px;">
                            <li class="list-group-item fist-item sem-itens" v-if="!mostrarItens">
                                <i class="fa fa-check-circle sem-itens-icone"></i>
                                <span class="TextoListagem">{{semItemTexto}}</span>
                            </li>
                            <li :class="['list-group-item TextoListagem', { 'fist-item' : index == 0 }]" v-for="(item, index) in itens">
                                <div class="TextoListagem linha-item">
                                    <span class="descricao-item">
                                        <i :class="retornaClassIcone(item)" :style="{ color: retornaClassCor(item) }"></i> {{ item.descricao }}
                                    </span>

                                    <span class="acoes-item">
                                        <span v-if="item.quantidade != null" class="label TextoQuantidades" :style="{ 'color': 'white', 'background-color' : retornaCorBadge(item) }">{{item.quantidade}}</span>

                                        <button v-if="item.aoClicar"
                                                type="button"
                                                class="btn btn-xs btn-default botao-abrir"
                                                @click="item.aoClicar()">
                                            <i class="fa fa-refresh"></i> Tentar novamente
                                        </button>

                                        <router-link v-if="item.rota"
                                                     class="btn btn-xs btn-primary botao-abrir"
                                                     tag="button"
                                                     type="button"
                                                     :to="item.rota"
                                                     :title="'Abrir ' + item.descricao">
                                            Abrir <i class="fa fa-arrow-right"></i>
                                        </router-link>
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <router-link v-if="textoBotao && rotaBotao"
                            class="btn btn-primary btn-block m-t"
                            tag="button"
                            tabindex="0"
                            type="button"
                            :to="rotaBotao">

                        <span class="MuiButton-label">{{textoBotao}}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<style scoped>
   .MuiTypography-h6 {
        font-size: 1.7rem;
        font-family: 'Maven Pro', sans-serif;
        font-weight: 550;
  }

  .TextoListagem {
        font-size: 16px;
        font-family: 'Maven Pro', sans-serif;
  }

  .TextoQuantidades {
        font-size: 13px;
  }

  .linha-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
  }

  .acoes-item {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        margin-left: 8px;
  }

  .botao-abrir {
        margin-left: 8px;
  }

  .sem-itens {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 14px 4px;
        color: #676a6c;
  }

  .sem-itens-icone {
        font-size: 22px;
        color: #1ab394;
        flex-shrink: 0;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/notificacoes/componentes/CardNotificacao.vue